module.exports = __webpack_public_path__ + "static/media/id-card-back.f0985f94.png";